import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type PhoneTextInputProps = React.InputHTMLAttributes<HTMLInputElement> &
  FieldWrapperPassThroughProps & {
    className?: string;
    disabled?: boolean;
    value: string;
    onChange: (value: string) => void;
  };
const PhoneTextInput = forwardRef<HTMLInputElement, PhoneTextInputProps>(
  ({ className, label, errorMessage, value, disabled = false, onChange, ...props }, ref) => {
    const inputId = label;

    return (
      <FieldWrapper
        label={label}
        errorMessage={errorMessage}
        float={true}
        className={className}
        htmlFor={inputId}
      >
        <IMaskInput
          overwrite
          inputRef={ref}
          id={inputId}
          type="tel"
          aria-required="true"
          value={value || '+1 '}
          disabled={disabled}
          placeholder={label}
          aria-invalid={errorMessage ? 'true' : 'false'}
          mask="+1 (000) 000-0000"
          onAccept={(value: string) => {
            const formatted = value.replace(/\+1|[() \-]/g, '');
            onChange(formatted);
          }}
          {...props}
          className={`iLendingCDX-text-field__float iLendingCDX-text-field__phoneInput ${
            errorMessage && 'iLendingCDX-text-field__float--error'
          }`}
        />
      </FieldWrapper>
    );
  }
);

export { PhoneTextInput };
